import { matches } from '@/mocks/matches';

const statusColors: Record<string, { bg: string; text: string; dot: string }> = {
  live: { bg: 'bg-primary-50', text: 'text-primary-600', dot: 'bg-primary-500' },
  upcoming: { bg: 'bg-accent-50', text: 'text-accent-700', dot: 'bg-accent-500' },
  finished: { bg: 'bg-secondary-100', text: 'text-secondary-600', dot: 'bg-secondary-400' },
};

const statusLabels: Record<string, string> = {
  live: '直播中',
  upcoming: '即将开始',
  finished: '已结束',
};

export default function HotMatches() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门赛事
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            实时追踪全球精彩对决
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {matches.map((match) => {
            const style = statusColors[match.status];
            return (
              <div
                key={match.id}
                className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-background-300 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs text-foreground-500 font-medium">{match.league}</span>
                  <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text}`}>
                    <span className={`w-1.5 h-1.5 rounded-full ${style.dot} ${match.status === 'live' ? 'animate-pulse' : ''}`}></span>
                    {statusLabels[match.status]}
                  </span>
                </div>

                <div className="flex items-center justify-between py-2">
                  <div className="flex-1 text-center">
                    <p className="font-heading font-semibold text-foreground-950 text-sm md:text-base whitespace-nowrap">{match.homeTeam}</p>
                  </div>
                  <div className="px-3 flex-shrink-0">
                    {match.homeScore !== null ? (
                      <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                        {match.homeScore} : {match.awayScore}
                      </span>
                    ) : (
                      <span className="font-heading text-lg text-foreground-400">VS</span>
                    )}
                  </div>
                  <div className="flex-1 text-center">
                    <p className="font-heading font-semibold text-foreground-950 text-sm md:text-base whitespace-nowrap">{match.awayTeam}</p>
                  </div>
                </div>

                <div className="mt-3 pt-3 border-t border-background-200/40">
                  <p className="text-xs text-foreground-500 text-center">{match.time}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}